import axios from 'axios';

const API_URL = 'https://jtc-admin.ddns.net/api';
//const API_URL = 'http://localhost:8080/api';
//const API_URL = 'http://192.168.0.53:3000/api';

const login = (username, password) => {
    return axios.post(`${API_URL}/login`, {
        username,
        password
    }); // 이제 토큰 저장은 AuthContext에서 담당
};

const refreshToken = (refreshToken) => {
    return axios.post(`${API_URL}/refresh-token`, refreshToken, {
        headers: {
            'Content-Type': 'text/plain' // 리프레시 토큰을 문자열로 보낼 경우
        }
    });
};

const authService = {
    login,
    refreshToken,
};

export default authService;